import "./newsComponent.css"
import {Post} from "react-vk";

export default function About () {

    return (
        <div className="news-container">
            <Post
                elementId={"vk_post_-217192911_6"}
                ownerId={-217192911}
                postId={6}
                hash={"qh6dSDFxD67x29WLa9rMPS2wcLys"} />
        </div>
    )
}